
import Vue, { PropType } from "vue";
import { ProfessionalViewModel } from "@/presentation/viewmodels/ProfessionalViewModel";
import DocumentPhotoComponent from "./DocumentPhoto.vue";
import ProfessionalApprovalComponent from "./ProfessionalApproval.vue";
import ProfessionalWorkingHoursComponent from "./ProfessionalWorkingHours.vue";
import UserLogoImageComponent from "./UserLogoImage.vue";

export default Vue.extend({
  name: "ProfessionalInfo",
  components: {
    ProfessionalApproval: ProfessionalApprovalComponent,
    ProfessionalWorkingHours: ProfessionalWorkingHoursComponent,
    DocumentPhoto: DocumentPhotoComponent,
    UserLogoImage: UserLogoImageComponent,
  },
  props: {
    // Busca e mapeamento pro viewmodel ficam no controller da tela
    // (UserDetailController) — este componente é só apresentação.
    // workingHours já vem embutido no próprio professional (data.working_hours).
    professional: {
      type: Object as PropType<ProfessionalViewModel | null>,
      required: false,
      default: null
    },
  },
});
